import { render, staticRenderFns } from "./notice_help.vue?vue&type=template&id=b571776a&scoped=true"
import script from "./notice_help.vue?vue&type=script&lang=js"
export * from "./notice_help.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b571776a",
  null
  
)

export default component.exports